import React, { useEffect } from "react";
import { createContext, useContext, useState } from "react";

export const StateContext = createContext()

export const StateProvider = ({ children }) => {
  const [loadingStates, setLoadingStates] = useState({})

  const setLoading = (key, isLoading) => {
    setLoadingStates((prev) => ({
      ...prev,
      [key]: isLoading
    }))
  }

  const isLoading = (key) => {
    return loadingStates[key] || false
  }

  return (
    <StateContext.Provider value={{
      setLoading,
      isLoading

    }}>
      {children}
    </StateContext.Provider>
  )
}

export const useStateContext = () => {
  return useContext(StateContext)
}